const invoice_store = {
    state: {
        selectedCustomer: {
            "id": null,
            "campaign_id": null,
            "gc_displayname": null,
            "phone_number": null,
            "owning_campaign_name": null,
            "note": null,
            "first_name": null,
            "middle_name": null,
            "last_name": null,
            "business_name": null,
        },
        contacts:  [],
        emails:  [],
        phones:  [],
        addresses:  [],
        selectedCampaignId: null,
        customerAgreementInvoices: [],
        activeTab: 'inventory',
        activeCampaignId: null,
        selectedFacility: {'id': null},
        showFacilityModal: false,
        showCustomerModal: false,
        missingArray: []
    },
    getters: {
        selectedCustomer: (state) => state.selectedCustomer,
        contacts: (state) => state.contacts,
        emails: (state) => state.emails,
        phones: (state) => state.phones,
        addresses: (state) => state.addresses,
        selectedFacility: (state) => state.selectedFacility,
        selectedCampaignId: (state) => state.selectedCampaignId,
        activeTab: (state) => state.activeTab,
        customerAgreementInvoices: (state) => state.customerAgreementInvoices,
        activeCampaignId: (state) => state.activeCampaignId,
        showFacilityModal: (state) => state.showFacilityModal,
        showCustomerModal: (state) => state.showCustomerModal,
        missingArray: (state) => state.missingArray
    },
    actions: {},
    mutations: {
        setSelectedCustomer: (state, payload) => (state.selectedCustomer = payload),
        setContacts: (state, payload) => (state.contacts = payload),
        setEmails: (state, payload) => (state.emails = payload),
        setPhones: (state, payload) => (state.phones = payload),
        setAddresses: (state, payload) => (state.addresses = payload),
        setSelectedFacility: (state, payload) => (state.selectedFacility = payload),
        setSelectedCampaignId: (state, payload) => (state.selectedCampaignId = payload),
        setActiveTab: (state, payload) => (state.activeTab = payload),
        setCustomerAgreementInvoices: (state, payload) => (state.customerAgreementInvoices = payload),
        setActiveCampaignId: (state, payload) => (state.activeCampaignId = payload),
        setShowFacilityModal: (state, payload) => (state.showFacilityModal = payload),
        setShowCustomerModal: (state, payload) => (state.showCustomerModal = payload),
        setMissingArray: (state, payload) => (state.missingArray = payload),
    }
};

export default invoice_store;
